export const ErrorCodes = {
	SUCCESS: '0',

	swsim: {
		GETRATES_FAILED: '5177601',
		GETRATES_FCIFLATS_ERROR: '4522428',
		GETRATES_FCIFLATS_WEIGHT_ERROR: '5177601',
		PHONE_VERIFICATION_REQUIRED: '4522357',
		ADMIN_HOLD_SELF_RELEASE: '4525577',
		IMPORT_LIC_NUMBER_REQ: 'Import License Number',
		INVALID_ADDRESS: '6226702',
		FEATURE_NOT_ENABLED: '6226724',
		UPS_ADD_CARRIER_ERROR: '4524046',
	},

	plugin: {
		LOAD_PRINTERS_FAILED: '1000',
		SCALE_CALIBRATE_FAILED: '1001',
		SECURITY_ASSET_FAILED: '1002',
		MARGIN_INFO_FAILED: '1003',
		PRINT_FAILED: '1005',
		PLUGIN_NOT_INSTALLED: '1006',
		PLUGIN_INITIALIZE_FAILED: '1007',
		REFRESH_PRINTERS_FAILED: '1032',
		NAWS_V3_NOT_RESPONDING: '1033',
	},

	shipstation: {
		ACCOUNT_CREATED: '5571334',
		ACCOUNT_ALREADY_EXIST: '5571331',
		MIGRATE_SHIPFROM_FAILED: '5571336',
		NOT_LOGGED_IN: '5571333',
		NOT_REGISTERED: '5571330',
		UNKNOWN_ERROR: '5571329',
	},

	storeRefreshStatus: {
		NOT_IMPORTING: 0, // idle / not importing
		WAITING: 1, // starting / waiting
		IMPORT_IN_PROGRESS: 2, // import in progress
		ERROR: 3, // the error state
		BACKEND_BUSY: 4, // (sdc custom error code) 'import in progress'
		ORDERS_UPLOADED: 5, // (sdc custom error code) 'orders uploaded'
		NO_ORDERS_UPLOADED: 6, // (sdc custom error code) 'no orders uploaded'
		NO_FILE_SELECTED: 7, // (sdc custom error code) 'no file selected'
		ERROR_RETURNED: 8, // (sdc custom error code) 'error message returned'
		INVALID_FILE_TYPE: 9, // (sdc custom error code) 'invalid file type'
	},

	common: {
		ADD_SHIP_FROM: '5571337',
		UPDATE_SHIP_FROM: '5571338',
		TIMEOUT: '5570823',
	},

	createManifest: {
		ERROR_RETURNED: 'CREATEMANIFESTERROR',
		DIFFERENT_ORIGINZIP: 'DIFFERENTORIGINZIP',
	},
};
